import { connect } from 'react-redux';
import { getUiBase } from '../../api/redux-watson/watson-config-selectors';

const mapStateToProps = state => ({
  uiBase: getUiBase(state),
});

export default function withUiBase(Component) {
  return connect(mapStateToProps)(Component);
}
